import { PermissaoEnum } from '../generated/backend-enums.js';
export { PermissaoEnum };
export const PermissaoLabelsMap = {
    // Gerais e Administração
    [PermissaoEnum.ADMIN]: { nome: 'Administrador', descricao: 'Acesso total ao sistema.' },
    [PermissaoEnum.OPERADOR]: { nome: 'Operador', descricao: 'Acesso operacional padrão.' },
    [PermissaoEnum.ROTA_ATENDIMENTO_CLIENTES]: {
        nome: 'Atendimento — Clientes',
        descricao: 'Acesso à listagem de clientes e ao Painel 360 no módulo de Atendimento.',
    },
    [PermissaoEnum.ROTA_PRODUTIVIDADE_ATENDIMENTO]: {
        nome: 'Atendimento — Produtividade',
        descricao: 'Acesso à página de produtividade pessoal do Atendimento.',
    },
    [PermissaoEnum.MENU_ADMIN]: { nome: 'Menu Admin', descricao: 'Visualização do menu de administração.' },
    [PermissaoEnum.PERMISSAO_FIND_ALL]: {
        nome: 'Listar Permissões',
        descricao: 'Permite visualizar todas as permissões cadastradas.',
    },
    // Jobs
    [PermissaoEnum.JOB_CREATE]: { nome: 'Criar Job', descricao: 'Permite a criação de novos jobs.' },
    [PermissaoEnum.JOB_UPDATE]: { nome: 'Editar Job', descricao: 'Permite a alteração de dados de jobs existentes.' },
    [PermissaoEnum.JOB_DELETE]: { nome: 'Excluir Job', descricao: 'Permite a exclusão de jobs.' },
    [PermissaoEnum.JOB_FIND_ALL]: {
        nome: 'Visualizar Todos Jobs',
        descricao: 'Acesso global a todos os jobs do sistema.',
    },
    [PermissaoEnum.PLANILHA_VIEW_FINANCE]: {
        nome: 'Ver Financeiro da Planilha',
        descricao: 'Permite visualizar dados financeiros sensíveis da planilha.',
    },
    [PermissaoEnum.JOB_FEELING_UPDATE]: {
        nome: 'Atualizar Feeling',
        descricao: 'Permite alterar o status de "feeling" do job.',
    },
    // Planejamento
    [PermissaoEnum.JOB_PLANEJAMENTO_CREATE]: {
        nome: 'Criar Planejamento',
        descricao: 'Permite criar planejamento para jobs.',
    },
    [PermissaoEnum.JOB_PLANEJAMENTO_UPDATE]: {
        nome: 'Editar Planejamento',
        descricao: 'Permite atualizar planejamentos.',
    },
    [PermissaoEnum.JOB_PLANEJAMENTO_DELETE]: {
        nome: 'Excluir Planejamento',
        descricao: 'Permite remover planejamentos.',
    },
    [PermissaoEnum.JOB_PLANEJAMENTO_FIND_ALL]: {
        nome: 'Ver Todos Planejamentos',
        descricao: 'Visualização total de planejamentos.',
    },
    // Planilhas (Geral e Atendimento)
    [PermissaoEnum.PLANILHA_CREATE]: { nome: 'Criar Planilha', descricao: 'Permite criar planilhas gerais.' },
    [PermissaoEnum.PLANILHA_UPDATE]: { nome: 'Editar Planilha', descricao: 'Permite editar planilhas gerais.' },
    [PermissaoEnum.PLANILHA_DELETE]: { nome: 'Excluir Planilha', descricao: 'Permite excluir planilhas.' },
    [PermissaoEnum.PLANILHA_FIND_ALL]: { nome: 'Visualizar Planilhas', descricao: 'Acesso à lista de planilhas.' },
    [PermissaoEnum.PLANILHA_INATIVAR]: {
        nome: 'Inativar Planilha',
        descricao: 'Permite desativar planilhas no sistema.',
    },
    [PermissaoEnum.PLANILHA_REATIVAR]: { nome: 'Reativar Planilha', descricao: 'Permite reativar planilhas inativas.' },
    [PermissaoEnum.PLANILHA_RECALCULAR]: {
        nome: 'Recalcular Planilha',
        descricao: 'Permite disparar o cálculo de fórmulas da planilha.',
    },
    [PermissaoEnum.ANO_COMPETENCIA_PLANILHA]: {
        nome: 'Gerenciar Ano Competência',
        descricao: 'Permite alterar o ano de competência das planilhas.',
    },
    // Planilha Atendimento
    [PermissaoEnum.PLANILHA_ATENDIMENTO_CREATE]: {
        nome: 'Criar Planilha Atendimento',
        descricao: 'Criação de planilhas de atendimento.',
    },
    [PermissaoEnum.PLANILHA_ATENDIMENTO_UPDATE]: {
        nome: 'Editar Planilha Atendimento',
        descricao: 'Edição de planilhas de atendimento.',
    },
    [PermissaoEnum.PLANILHA_ATENDIMENTO_DELETE]: {
        nome: 'Excluir Planilha Atendimento',
        descricao: 'Exclusão de planilhas de atendimento.',
    },
    [PermissaoEnum.PLANILHA_ATENDIMENTO_FIND_ALL]: {
        nome: 'Ver Todas Planilhas Atendimento',
        descricao: 'Acesso total às planilhas de atendimento.',
    },
    // Planilha Pré-Produção e Compras
    [PermissaoEnum.PLANILHA_PRE_CREATE]: {
        nome: 'Criar Planilha Pré',
        descricao: 'Criação de planilhas de pré-produção.',
    },
    [PermissaoEnum.PLANILHA_PRE_UPDATE]: {
        nome: 'Editar Planilha Pré',
        descricao: 'Edição de planilhas de pré-produção.',
    },
    [PermissaoEnum.PLANILHA_PRE_DELETE]: {
        nome: 'Excluir Planilha Pré',
        descricao: 'Exclusão de planilhas de pré-produção.',
    },
    [PermissaoEnum.PLANILHA_PRE_FIND_ALL]: {
        nome: 'Ver Planilhas Pré',
        descricao: 'Acesso às planilhas de pré-produção.',
    },
    [PermissaoEnum.PLANILHA_PRE_ALOCAR_PRE_PRODUTOR]: {
        nome: 'Alocar Pré-Produtor',
        descricao: 'Permite alocar o pré-produtor da equipe na planilha de pré-produção.',
    },
    [PermissaoEnum.PLANILHA_COMPRAS_CREATE]: {
        nome: 'Criar Planilha Compras',
        descricao: 'Criação de planilhas de compras.',
    },
    [PermissaoEnum.PLANILHA_COMPRAS_UPDATE]: {
        nome: 'Editar Planilha Compras',
        descricao: 'Edição de planilhas de compras.',
    },
    [PermissaoEnum.PLANILHA_COMPRAS_DELETE]: {
        nome: 'Excluir Planilha Compras',
        descricao: 'Exclusão de planilhas de compras.',
    },
    [PermissaoEnum.PLANILHA_COMPRAS_FIND_ALL]: {
        nome: 'Ver Planilhas Compras',
        descricao: 'Acesso às planilhas de compras.',
    },
    // Autorizações de Pagamento (AP)
    [PermissaoEnum.AP_CREATE]: { nome: 'Criar AP', descricao: 'Permite criar solicitações de autorização de pagamento.' },
    [PermissaoEnum.AP_UPDATE]: { nome: 'Editar AP', descricao: 'Permite editar autorizações de pagamento.' },
    [PermissaoEnum.AP_FIND_ALL]: {
        nome: 'Ver Todas APs',
        descricao: 'Visualização de todas as autorizações de pagamento.',
    },
    // Lotes e Versões
    [PermissaoEnum.VERSAO_CREATE]: { nome: 'Criar Versão', descricao: 'Permite criar novas versões de planilhas.' },
    [PermissaoEnum.VERSAO_UPDATE]: { nome: 'Editar Versão', descricao: 'Permite atualizar versões.' },
    [PermissaoEnum.VERSAO_FIND_ALL]: { nome: 'Ver Versões', descricao: 'Visualização de histórico de versões.' },
    [PermissaoEnum.VERSAO_ENVIAR_PROPOSTA_CLIENTE]: {
        nome: 'Enviar Proposta',
        descricao: 'Permite o envio formal da proposta ao cliente.',
    },
    [PermissaoEnum.VERSAO_APROVAR_ETAPA_CLIENTE]: {
        nome: 'Aprovar como Cliente',
        descricao: 'Permite aprovar a versão na etapa do cliente, em nome do cliente.',
    },
    // Desaprovações
    [PermissaoEnum.VERSAO_DESAPROVAR_PRE_CLIENTE]: {
        nome: 'Desaprovar Pré-Cliente',
        descricao: 'Rejeitar versão na etapa pré-cliente.',
    },
    [PermissaoEnum.VERSAO_DESAPROVAR_PRE_INTERNO]: {
        nome: 'Desaprovar Pré-Interno',
        descricao: 'Rejeitar versão na etapa interna.',
    },
    [PermissaoEnum.VERSAO_DESAPROVAR_COMPRAS]: {
        nome: 'Desaprovar Compras',
        descricao: 'Rejeitar versão na etapa de compras.',
    },
    [PermissaoEnum.VERSAO_DESAPROVAR_ATENDIMENTO]: {
        nome: 'Desaprovar Atendimento',
        descricao: 'Rejeitar versão na etapa de atendimento.',
    },
    [PermissaoEnum.VERSAO_RESOLVER_APROVACAO_PARCIAL]: {
        nome: 'Resolver Aprovação Parcial',
        descricao: 'Permite incrementar ou concluir uma aprovação parcial no atendimento.',
    },
    // Créditos e Verba
    [PermissaoEnum.CREDITO_CREATE]: { nome: 'Criar Crédito', descricao: 'Permite criar registros de crédito.' },
    [PermissaoEnum.CREDITO_UPDATE]: { nome: 'Editar Crédito', descricao: 'Permite editar registros de crédito.' },
    [PermissaoEnum.CREDITO_FIND_ALL]: { nome: 'Ver Créditos', descricao: 'Visualizar listagem de créditos.' },
    [PermissaoEnum.GRUPO_CREDITO_CREATE]: { nome: 'Criar Grupo de Crédito', descricao: 'Permite agrupar créditos.' },
    [PermissaoEnum.GRUPO_CREDITO_UPDATE]: {
        nome: 'Editar Grupo de Crédito',
        descricao: 'Editar grupos de créditos existentes.',
    },
    [PermissaoEnum.GRUPO_CREDITO_DELETE]: { nome: 'Excluir Grupo de Crédito', descricao: 'Excluir grupos de créditos.' },
    [PermissaoEnum.GRUPO_CREDITO_FIND_ALL]: {
        nome: 'Ver Grupos de Crédito',
        descricao: 'Visualizar listagem de grupos de crédito.',
    },
    // Faturamento e Conciliação
    [PermissaoEnum.FATURAMENTO_ATENDIMENTO_CREATE]: {
        nome: 'Faturamento Atendimento (Criar)',
        descricao: 'Criar faturamento via atendimento.',
    },
    [PermissaoEnum.FATURAMENTO_ATENDIMENTO_UPDATE]: {
        nome: 'Faturamento Atendimento (Editar)',
        descricao: 'Editar faturamento de atendimento.',
    },
    [PermissaoEnum.FATURAMENTO_ATENDIMENTO_FIND_ALL]: {
        nome: 'Faturamento Atendimento (Ver)',
        descricao: 'Listar faturamentos de atendimento.',
    },
    [PermissaoEnum.FATURAMENTO_ATENDIMENTO_CANCEL]: {
        nome: 'Cancelar Faturamento',
        descricao: 'Cancelar faturamentos de atendimento.',
    },
    [PermissaoEnum.FATURAMENTO_FINANCEIRO_CREATE]: {
        nome: 'Faturamento Financeiro (Criar)',
        descricao: 'Criar faturamento via financeiro.',
    },
    [PermissaoEnum.FATURAMENTO_FINANCEIRO_UPDATE]: {
        nome: 'Faturamento Financeiro (Editar)',
        descricao: 'Editar faturamento financeiro.',
    },
    [PermissaoEnum.FATURAMENTO_FINANCEIRO_FIND_ALL]: {
        nome: 'Faturamento Financeiro (Ver)',
        descricao: 'Listar faturamentos financeiros.',
    },
    [PermissaoEnum.ROTA_CUSTO_FIXO]: {
        nome: 'Gerenciar Custo Fixo',
        descricao: 'Acesso à página de custo fixo (visualizar e lançar). Restrito a C-levels.',
    },
    [PermissaoEnum.COMUNICADO_SISTEMA_MANAGE]: {
        nome: 'Gerenciar Comunicados',
        descricao: 'Criar, publicar e arquivar comunicados do sistema (avisos globais).',
    },
    [PermissaoEnum.MENU_CUSTO_FIXO]: {
        nome: 'Menu Custo Fixo',
        descricao: 'Exibe o módulo de gestão de custo fixo (novo modelo) na navegação.',
    },
    [PermissaoEnum.MENU_FACILITIES]: {
        nome: 'Menu Facilities',
        descricao: 'Exibe o módulo de Facilities (gestão administrativa) na navegação.',
    },
    [PermissaoEnum.CENTRO_CUSTO_MANAGE]: {
        nome: 'Gerenciar Centros de Custo',
        descricao: 'Criar, editar e inativar centros de custo. Exclusiva do Admin.',
    },
    [PermissaoEnum.CATALOGO_CUSTO_MANAGE]: {
        nome: 'Gerenciar Catálogo de Custo',
        descricao: 'Criar, editar e inativar naturezas e elementos de custo (o que é / o que se paga).',
    },
    [PermissaoEnum.CUSTO_FIXO_CREATE]: {
        nome: 'Cadastrar Contrato Recorrente',
        descricao: 'Cadastrar contratos de custo recorrente, gerando o cronograma de parcelas.',
    },
    [PermissaoEnum.CUSTO_FIXO_UPDATE]: {
        nome: 'Editar Custo Recorrente',
        descricao: 'Editar e reajustar contratos, confirmar o pagamento das parcelas e encerrar contratos.',
    },
    [PermissaoEnum.CUSTO_FIXO_FIND_ALL]: {
        nome: 'Consultar Custo Recorrente',
        descricao: 'Listar e consultar contratos recorrentes e suas parcelas.',
    },
    [PermissaoEnum.CUSTO_FIXO_TODOS_CENTROS]: {
        nome: 'Custo Fixo em Todos os Centros',
        descricao: 'Editar em qualquer centro de custo, não só nos que a pessoa é responsável (abrangência global de edição).',
    },
    [PermissaoEnum.CUSTO_FIXO_VER_TODOS_CENTROS]: {
        nome: 'Custo Fixo — Ver Todos os Centros',
        descricao: 'Ver qualquer centro de custo sem editar nenhum por este eixo (abrangência global de leitura). Não concedida a nenhum cargo nesta entrega.',
    },
    // Base de Contatos
    [PermissaoEnum.ROTA_ATENDIMENTO_CONTATOS]: {
        nome: 'Atendimento — Contatos',
        descricao: 'Acesso à Base de Contatos no módulo de Atendimento (área piloto).',
    },
    [PermissaoEnum.ROTA_PRE_PRODUCAO_CONTATOS]: {
        nome: 'Pré-produção — Contatos',
        descricao: 'Acesso à Base de Contatos no módulo de Pré-produção.',
    },
    [PermissaoEnum.ROTA_COMPRAS_CONTATOS]: {
        nome: 'Compras — Contatos',
        descricao: 'Acesso à Base de Contatos no módulo de Compras.',
    },
    [PermissaoEnum.ROTA_FACILITIES_CONTATOS]: {
        nome: 'Facilities — Contatos',
        descricao: 'Acesso à Base de Contatos no módulo de Facilities.',
    },
    [PermissaoEnum.ROTA_FACILITIES_ENVIOS]: {
        nome: 'Facilities — Gifts',
        descricao: 'Acesso à lista de gifts (pedidos e cada gift a concluir) do módulo de Facilities.',
    },
    [PermissaoEnum.CONTATO_ENVIOS_EXPORTAR]: {
        nome: 'Contatos — Baixar planilha de envios',
        descricao: 'Baixar a planilha com endereço e telefone pessoal dos contatos das tarefas de envio. Cada download fica no diário do contato.',
    },
    [PermissaoEnum.TAREFA_ENVIOS_CONCLUIR]: {
        nome: 'Envios — Concluir em lote',
        descricao: 'Marcar várias tarefas de envio de aniversário como enviadas de uma vez.',
    },
    [PermissaoEnum.CONTATO_FIND_ALL]: {
        nome: 'Contatos — Consultar',
        descricao: 'Ver a base de contatos: listagem, ficha e histórico (dado pessoal fica mascarado).',
    },
    [PermissaoEnum.CONTATO_CREATE]: {
        nome: 'Contatos — Cadastrar',
        descricao: 'Cadastrar novos contatos.',
    },
    [PermissaoEnum.CONTATO_UPDATE]: {
        nome: 'Contatos — Alterar',
        descricao: 'Editar, confirmar dados, mudar de empresa, marcar "não contatar" e inativar contatos.',
    },
    [PermissaoEnum.CONTATO_DADOS_PESSOAIS_VER]: {
        nome: 'Contatos — Dados pessoais',
        descricao: 'Ver e editar endereço, telefone pessoal e observações. Cada "Mostrar" fica registrado.',
    },
    [PermissaoEnum.CONTATO_ANONIMIZAR]: {
        nome: 'Contatos — Eliminar a pedido',
        descricao: 'Executar o procedimento de eliminação (anonimização) a pedido do titular, conforme a LGPD.',
    },
    [PermissaoEnum.CONTATO_MESCLAR]: {
        nome: 'Contatos — Mesclar cadastros',
        descricao: 'Juntar dois cadastros da mesma pessoa. Exige também ver dados pessoais.',
    },
    [PermissaoEnum.CONTATO_VER_TODOS]: {
        nome: 'Contatos — Ver todos os contatos',
        descricao: 'Ver todos os contatos da base, mesmo sem ser responsável por eles. Editar continua só para quem é responsável.',
    },
    [PermissaoEnum.CONTATO_TIPO_CLIENTE_VER]: {
        nome: 'Contatos — Ver clientes',
        descricao: 'Enxergar na base os contatos de clientes. Sem ela, esses contatos nem aparecem.',
    },
    [PermissaoEnum.CONTATO_TIPO_CLIENTE_GERIR]: {
        nome: 'Contatos — Cadastrar e editar clientes',
        descricao: 'Cadastrar e editar contatos de clientes. Exige também ver esse tipo.',
    },
    [PermissaoEnum.CONTATO_TIPO_FORNECEDOR_VER]: {
        nome: 'Contatos — Ver fornecedors',
        descricao: 'Enxergar na base os contatos de fornecedores. Sem ela, esses contatos nem aparecem.',
    },
    [PermissaoEnum.CONTATO_TIPO_FORNECEDOR_GERIR]: {
        nome: 'Contatos — Cadastrar e editar fornecedors',
        descricao: 'Cadastrar e editar contatos de fornecedores. Exige também ver esse tipo.',
    },
    [PermissaoEnum.CONTATO_TIPO_PARCEIRO_VER]: {
        nome: 'Contatos — Ver parceiros',
        descricao: 'Enxergar na base os contatos de parceiros. Sem ela, esses contatos nem aparecem.',
    },
    [PermissaoEnum.CONTATO_TIPO_PARCEIRO_GERIR]: {
        nome: 'Contatos — Cadastrar e editar parceiros',
        descricao: 'Cadastrar e editar contatos de parceiros. Exige também ver esse tipo.',
    },
    [PermissaoEnum.CUSTO_BUDGET_MANAGE]: {
        nome: 'Gerenciar Orçamento (Budget)',
        descricao: 'Criar, editar e enviar revisões de orçamento para aprovação da Diretoria.',
    },
    [PermissaoEnum.CUSTO_BUDGET_FIND_ALL]: {
        nome: 'Consultar Orçamento (Budget)',
        descricao: 'Listar e consultar revisões de orçamento e seu histórico.',
    },
    [PermissaoEnum.ROTA_APROVACAO_BUDGET_DECIDIR]: {
        nome: 'Decidir Aprovações de Orçamento',
        descricao: 'Acessar e decidir a fila de aprovação de orçamento anual (Diretoria).',
    },
    [PermissaoEnum.FECHAMENTO_FECHAR]: {
        nome: 'Fechar o Mês de Custo Fixo',
        descricao: 'Editar o grid do fechamento mensal, fechá-lo e reabri-lo.',
    },
    [PermissaoEnum.DESPESA_PROJETO_CREATE]: {
        nome: 'Lançar Despesa Extraordinária',
        descricao: 'Lançar despesa extraordinária para Jobs da própria equipe (Produção).',
    },
    [PermissaoEnum.DESPESA_PROJETO_FIND_ALL]: {
        nome: 'Ver Despesas Extraordinárias',
        descricao: 'Listar e visualizar despesas extraordinárias e sua timeline.',
    },
    [PermissaoEnum.DESPESA_PROJETO_UPDATE]: {
        nome: 'Movimentar Despesa Extraordinária',
        descricao: 'Enviar para aprovação e estornar despesas extraordinárias.',
    },
    [PermissaoEnum.DESPESA_PROJETO_CANCELAR]: {
        nome: 'Cancelar Despesa Extraordinária',
        descricao: 'Cancelar uma despesa extraordinária aprovada que não deveria existir.',
    },
    [PermissaoEnum.COMISSAO_CREATE]: {
        nome: 'Lançar Comissão',
        descricao: 'Lançar comissão (Controladoria).',
    },
    [PermissaoEnum.COMISSAO_FIND_ALL]: {
        nome: 'Ver Comissões',
        descricao: 'Listar e visualizar comissões e sua timeline.',
    },
    [PermissaoEnum.COMISSAO_UPDATE]: {
        nome: 'Movimentar Comissão',
        descricao: 'Enviar para aprovação e estornar comissões.',
    },
    [PermissaoEnum.COMISSAO_CANCELAR]: {
        nome: 'Cancelar Comissão',
        descricao: 'Cancelar uma comissão aprovada que não deveria existir.',
    },
    [PermissaoEnum.COMISSAO_CONSOLIDAR]: {
        nome: 'Consolidar Comissão',
        descricao: 'Aprovar uma comissão em rascunho (rascunho/reprovada → aprovada).',
    },
    [PermissaoEnum.ROTA_APROVACAO_DESPESA_DECIDIR]: {
        nome: 'Decidir Aprovações de Despesas',
        descricao: 'Acessar e decidir a fila de aprovação de despesas de projeto.',
    },
    [PermissaoEnum.APROVACAO_CONFIG_MANAGE]: {
        nome: 'Configurar Fluxos de Aprovação',
        descricao: 'Definir as etapas, cargos e ordem dos fluxos de aprovação (Admin).',
    },
    [PermissaoEnum.CONCILIACAO_APS_RENTABILIDADE_UPDATE]: {
        nome: 'Editar Conciliação/Rentabilidade',
        descricao: 'Ajustar dados de conciliação e rentabilidade.',
    },
    [PermissaoEnum.CONCILIACAO_APS_RENTABILIDADE_FIND_ALL]: {
        nome: 'Ver Conciliações/Rentabilidade',
        descricao: 'Visualizar dados de conciliação.',
    },
    // Pessoas e Roles
    [PermissaoEnum.PESSOA_CREATE]: { nome: 'Criar Pessoa', descricao: 'Cadastrar novos usuários/pessoas no sistema.' },
    [PermissaoEnum.PESSOA_DELETE]: { nome: 'Excluir Pessoa', descricao: 'Remover usuários do sistema.' },
    [PermissaoEnum.PESSOA_ADD_ROLE]: { nome: 'Atribuir Cargo', descricao: 'Adicionar cargos a uma pessoa.' },
    [PermissaoEnum.PESSOA_REMOVE_ROLE]: { nome: 'Remover Cargo', descricao: 'Retirar cargos de uma pessoa.' },
    [PermissaoEnum.PESSOA_FIND_ALL]: { nome: 'Listar Pessoas', descricao: 'Visualizar todos os usuários cadastrados.' },
    [PermissaoEnum.ROLE_ADD_PERMISSAO]: {
        nome: 'Adicionar Permissão ao Cargo',
        descricao: 'Vincular novas permissões a um cargo.',
    },
    [PermissaoEnum.ROLE_REMOVE_PERMISSAO]: {
        nome: 'Remover Permissão do Cargo',
        descricao: 'Retirar permissões de um cargo.',
    },
    [PermissaoEnum.ROLE_FIND_ALL]: { nome: 'Listar Cargos', descricao: 'Visualizar todos os cargos/funções.' },
    // Aprovadores e Tarefas
    [PermissaoEnum.APROVADOR_PRE_PRODUCAO]: {
        nome: 'Aprovador de Pré-Produção',
        descricao: 'Usuário com autoridade para aprovar pré-produção.',
    },
    [PermissaoEnum.APROVADOR_COMPRAS]: {
        nome: 'Aprovador de Compras',
        descricao: 'Usuário com autoridade para aprovar compras.',
    },
    [PermissaoEnum.TAREFA_SOLICITAR_AP]: {
        nome: 'Solicitar AP',
        descricao: 'Permite criar tarefa de solicitação de AP.',
    },
    [PermissaoEnum.TAREFA_SOLICITAR_AJUSTE_AP]: {
        nome: 'Questionar AP',
        descricao: 'Permite questionar a AP.',
    },
    [PermissaoEnum.TAREFA_COBRAR_APROVACAO_AP]: {
        nome: 'Cobrar Aprovação de AP',
        descricao: 'Permite criar tarefa de cobrança de aprovação de AP para a controladoria.',
    },
    [PermissaoEnum.TAREFA_SOLICITAR_DESFATURAMENTO]: {
        nome: 'Solicitar Desfaturamento',
        descricao: 'Permite criar tarefa pedindo ao financeiro o desfaturamento de um faturamento.',
    },
    [PermissaoEnum.TAREFA_PEDIR_BRINDE_CONTATO]: {
        nome: 'Pedir Aniversário de Contato',
        descricao: 'Permite pedir ao Facilities a lembrança de aniversário de um ou mais contatos.',
    },
    [PermissaoEnum.TAREFA_SOLICITAR_AJUSTE_ATENDIMENTO]: {
        nome: 'Questionar Atendimento',
        descricao: 'Permite questionar o atendimento.',
    },
    [PermissaoEnum.TAREFA_SOLICITAR_ORCAMENTO_PRE_PRODUCAO]: {
        nome: 'Solicitar Orçamento Pré-Produção',
        descricao: 'Permite solicitar orçamento de pré-produção.',
    },
    [PermissaoEnum.CRIAR_TAREFA_GENERICA]: {
        nome: 'Criar Tarefa Genérica',
        descricao: 'Permite criar tarefas genéricas e de upload de arquivo no job.',
    },
    // Downloads
    [PermissaoEnum.DOWNLOAD_PLANILHA_INTERNA]: {
        nome: 'Download Planilha Interna',
        descricao: 'Baixar versão interna da planilha.',
    },
    [PermissaoEnum.DOWNLOAD_PLANILHA_INTERNA_COMPRAS]: {
        nome: 'Download Planilha Compras',
        descricao: 'Baixar planilha para setor de compras.',
    },
    [PermissaoEnum.DOWNLOAD_PLANILHA_CLIENTE]: {
        nome: 'Download Planilha Cliente',
        descricao: 'Baixar planilha versão cliente.',
    },
    [PermissaoEnum.DOWNLOAD_PLANILHA_CLIENTE_ATENDIMENTO]: {
        nome: 'Download Planilha Cliente (Atend.)',
        descricao: 'Baixar planilha cliente via atendimento.',
    },
    [PermissaoEnum.DOWNLOAD_PLANILHA_APROVACAO]: {
        nome: 'Download Planilha Aprovação',
        descricao: 'Baixar documento de aprovação.',
    },
    [PermissaoEnum.DOWNLOAD_PLANILHA_AP]: {
        nome: 'Download AP',
        descricao: 'Baixar arquivo de Autorização de Pagamento.',
    },
    [PermissaoEnum.DOWNLOAD_BRIEFING_JOB]: { nome: 'Download Briefing', descricao: 'Baixar o briefing do job.' },
    [PermissaoEnum.DOWNLOAD_PAPER_JOB]: { nome: 'Download Paper', descricao: 'Baixar o paper do job.' },
    [PermissaoEnum.DOWNLOAD_ESTUDO_VERBA_JOB]: {
        nome: 'Download Estudo de Verba',
        descricao: 'Baixar o estudo de verba do job.',
    },
    [PermissaoEnum.DOWNLOAD_PROJETO_EXECUTIVO_JOB]: {
        nome: 'Download Projeto Executivo',
        descricao: 'Baixar o projeto executivo do job.',
    },
    [PermissaoEnum.DOWNLOAD_PROJETO_FINAL_JOB]: {
        nome: 'Download Projeto Final',
        descricao: 'Baixar o projeto final do job.',
    },
    [PermissaoEnum.DOWNLOAD_ORDEM_COMPRA]: { nome: 'Download Ordem de Compra', descricao: 'Baixar arquivo de OC.' },
    [PermissaoEnum.DOWNLOAD_NOTA_FISCAL]: { nome: 'Download Nota Fiscal', descricao: 'Baixar arquivos de NF.' },
    [PermissaoEnum.DOWNLOAD_COMPROVANTE_ENTREGA_FATURAMENTO]: {
        nome: 'Download Comprovante Entrega',
        descricao: 'Baixar comprovantes de faturamento.',
    },
    [PermissaoEnum.DOWNLOAD_EVIDENCIA_BRINDE]: {
        nome: 'Download Foto do Gift',
        descricao: 'Ver a foto que comprova o gift de um pedido.',
    },
    [PermissaoEnum.DOWNLOAD_APRESENTACAO_JOB_PLANEJAMENTO]: {
        nome: 'Download Apresentação Planejamento',
        descricao: 'Baixar PPT/PDF de planejamento.',
    },
    // Menus e Rotas (Navegação)
    [PermissaoEnum.MENU_ATENDIMENTO]: { nome: 'Menu Atendimento', descricao: 'Exibe o menu de atendimento.' },
    [PermissaoEnum.MENU_PLANEJAMENTO]: { nome: 'Menu Planejamento', descricao: 'Exibe o menu de planejamento.' },
    [PermissaoEnum.MENU_PRE_PRODUCAO]: { nome: 'Menu Pré-Produção', descricao: 'Exibe o menu de pré-produção.' },
    [PermissaoEnum.MENU_COMPRAS]: { nome: 'Menu Compras', descricao: 'Exibe o menu de compras.' },
    [PermissaoEnum.MENU_PRODUCAO]: { nome: 'Menu Produção', descricao: 'Exibe o menu de produção.' },
    [PermissaoEnum.MENU_CONTROLADORIA]: {
        nome: 'Menu Controladoria',
        descricao: 'Exibe o menu de controladoria (comissões).',
    },
    [PermissaoEnum.MENU_APROVACOES]: { nome: 'Menu Aprovações', descricao: 'Exibe o menu de aprovações.' },
    [PermissaoEnum.MENU_DASHBOARD]: { nome: 'Menu Dashboard', descricao: 'Exibe o menu de indicadores.' },
    [PermissaoEnum.MENU_PRODUCAO_FINANCEIRO]: {
        nome: 'Menu Prod. Financeiro',
        descricao: 'Exibe o menu financeiro de produção.',
    },
    [PermissaoEnum.MENU_FINANCEIRO]: { nome: 'Menu Financeiro', descricao: 'Exibe o menu financeiro geral.' },
    [PermissaoEnum.RELATORIO_PLANILHA_ATENDIMENTO]: {
        nome: 'Relatório Planilha Atendimento',
        descricao: 'Acesso a relatórios específicos.',
    },
    // Rotas Específicas
    [PermissaoEnum.ROTA_JOB]: { nome: 'Rota Jobs', descricao: 'Acesso à URL de jobs.' },
    [PermissaoEnum.ROTA_JOB_AGENDA]: { nome: 'Rota Agenda Jobs', descricao: 'Acesso à URL de agenda de jobs.' },
    [PermissaoEnum.ROTA_TECNOLOGIA_AGENDA]: {
        nome: 'Rota Agenda Tecnologia',
        descricao: 'Acesso à URL de agenda de tecnologia.',
    },
    [PermissaoEnum.ROTA_PLANEJAMENTO_AGENDA]: {
        nome: 'Rota Agenda Planejamento',
        descricao: 'Acesso à URL de agenda de planejamento.',
    },
    [PermissaoEnum.ROTA_PRE_PRODUCAO_AGENDA]: {
        nome: 'Rota Agenda Pré-Produção',
        descricao: 'Acesso à URL de agenda de pré-produção.',
    },
    [PermissaoEnum.ROTA_PLANEJAMENTO]: { nome: 'Rota Planejamento', descricao: 'Acesso à URL de planejamento.' },
    [PermissaoEnum.ROTA_PLANILHAS_ATENDIMENTO]: {
        nome: 'Rota Planilhas Atend.',
        descricao: 'Acesso às rotas de atendimento.',
    },
    [PermissaoEnum.ROTA_PLANILHAS_PRE_PRODUCAO]: {
        nome: 'Rota Planilhas Pré',
        descricao: 'Acesso às rotas de pré-produção.',
    },
    [PermissaoEnum.ROTA_PLANILHAS_COMPRAS]: { nome: 'Rota Planilhas Compras', descricao: 'Acesso às rotas de compras.' },
    [PermissaoEnum.ROTA_PLANILHAS_PRODUCAO]: {
        nome: 'Rota Planilhas Produção',
        descricao: 'Acesso às rotas de produção.',
    },
    [PermissaoEnum.ROTA_PLANILHAS_APROVACAO]: { nome: 'Rota Aprovações', descricao: 'Acesso às rotas de aprovação.' },
    [PermissaoEnum.ROTA_USUARIOS]: { nome: 'Rota Usuários', descricao: 'Acesso às rotas de gestão de usuários.' },
    [PermissaoEnum.ROTA_PERMISSOES]: { nome: 'Rota Permissões', descricao: 'Acesso às rotas de gestão de permissões.' },
    [PermissaoEnum.ROTA_TAREFAS_ADMIN]: { nome: 'Rota Tarefas Admin', descricao: 'Acesso às tarefas administrativas.' },
    [PermissaoEnum.ROTA_CLIENTES_ADMIN]: { nome: 'Rota Clientes Admin', descricao: 'Acesso à gestão de clientes.' },
    [PermissaoEnum.ROTA_SQUADS_ADMIN]: { nome: 'Rota Squads Admin', descricao: 'Acesso à gestão de squads.' },
    [PermissaoEnum.ROTA_ARQUIVOS_ADMIN]: {
        nome: 'Rota Arquivos Admin',
        descricao: 'Acesso à auditoria de arquivos e histórico de downloads.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_EXECUTIVO_ATENDIMENTO]: {
        nome: 'Dashboard Atend. Executivo',
        descricao: 'Acesso ao dashboard de alta gestão.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_EXECUTIVO]: {
        nome: 'Dashboard Executivo',
        descricao: 'Acesso ao dashboard de alta gestão.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_ATENDIMENTO_SNAPSHOTS]: {
        nome: 'Dashboard Atend. Snapshots',
        descricao: 'Acesso ao dashboard de snapshots de atendimento.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_PRE_PRODUCAO_JOBS]: {
        nome: 'Dashboard Pré-Produção Jobs',
        descricao: 'Acesso ao dashboard de jobs de pré-produção.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_PRE_PRODUCAO_PLANILHAS]: {
        nome: 'Dashboard Pré-Produção Planilhas',
        descricao: 'Acesso ao dashboard de planilhas de pré-produção.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_PRE_PRODUCAO_EQUIPE]: {
        nome: 'Dashboard Pré-Produção Equipe',
        descricao: 'Acesso ao dashboard de equipe de pré-produção.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_COMPRAS]: {
        nome: 'Dashboard Compras',
        descricao: 'Acesso ao dashboard de compras.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_EQUIPE_COMPRAS]: {
        nome: 'Dashboard Equipe Compras',
        descricao: 'Acesso ao dashboard da equipe de compras.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_ATENDIMENTO_CREDITOS]: {
        nome: 'Dashboard Atend. Créditos',
        descricao: 'Indicadores específicos do atendimento.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_ATENDIMENTO_PLANILHAS]: {
        nome: 'Dashboard Atend. Planilhas',
        descricao: 'Indicadores específicos de pré-produção.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_ADIANTAMENTOS_FINANCEIRO]: {
        nome: 'Dashboard Adiantamentos Financeiro',
        descricao: 'Acesso ao dashboard de adiantamentos financeiros.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_DIRETORIA_ATENDIMENTO]: {
        nome: 'Dashboard Dir. Atendimento',
        descricao: 'Indicadores da diretoria de atendimento.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_DIRETORIA_PRE_PRODUCAO]: {
        nome: 'Dashboard Dir. Pré',
        descricao: 'Indicadores da diretoria de pré-produção.',
    },
    [PermissaoEnum.ROTA_DASHBOARD_DIRETORIA_COMPRAS]: {
        nome: 'Dashboard Dir. Compras',
        descricao: 'Indicadores da diretoria de compras.',
    },
    [PermissaoEnum.ROTA_PLANILHAS_PRODUCAO_FINANCEIRO_APS]: {
        nome: 'Rota Financeiro/APs',
        descricao: 'Acesso às APs e financeiro de produção.',
    },
    [PermissaoEnum.ROTA_VERSOES_PRE_PRODUCAO]: {
        nome: 'Rota Versões Pré',
        descricao: 'Acesso às versões de pré-produção.',
    },
    [PermissaoEnum.ROTA_FATURAMENTOS_ATENDIMENTO]: {
        nome: 'Rota Faturamentos Atend.',
        descricao: 'Gestão de faturamentos de atendimento.',
    },
    [PermissaoEnum.ROTA_CREDITAVEIS_ATENDIMENTO]: {
        nome: 'Rota Creditáveis Atend.',
        descricao: 'Visualização de itens creditáveis.',
    },
    [PermissaoEnum.ROTA_FATURAMENTOS_FINANCEIRO]: {
        nome: 'Rota Faturamentos Finan.',
        descricao: 'Gestão de faturamentos financeiros.',
    },
    [PermissaoEnum.ROTA_CONCILIACOES_PRODUCAO_FINANCEIRO]: {
        nome: 'Rota Conciliações',
        descricao: 'Gestão de conciliações financeiras.',
    },
    [PermissaoEnum.ROTA_PROCESSAMENTO_IA_ADMIN]: {
        nome: 'Rota Processamento IA',
        descricao: 'Acesso às rotas de processamento de IA.',
    },
    [PermissaoEnum.MENU_TECNOLOGIA]: { nome: 'Menu Tecnologia', descricao: 'Visualização do menu de tecnologia.' },
    [PermissaoEnum.ROTA_TECNOLOGIA_JOBS]: {
        nome: 'Rota Jobs Tecnologia',
        descricao: 'Acesso à rota de jobs de tecnologia.',
    },
    [PermissaoEnum.JOB_TECNOLOGIA_FIND_ALL]: {
        nome: 'Visualizar Jobs de Tecnologia',
        descricao: 'Acesso à visualização de jobs de tecnologia.',
    },
    [PermissaoEnum.JOB_TECNOLOGIA_CREATE]: {
        nome: 'Criar Job de Tecnologia',
        descricao: 'Acesso à criação de jobs de tecnologia.',
    },
    [PermissaoEnum.JOB_TECNOLOGIA_UPDATE]: {
        nome: 'Editar Job de Tecnologia',
        descricao: 'Acesso à edição de jobs de tecnologia.',
    },
    // Criação
    [PermissaoEnum.JOB_CRIACAO_FIND_ALL]: {
        nome: 'Visualizar Jobs de Criação',
        descricao: 'Acesso à visualização de jobs no módulo de Criação (sem dados financeiros).',
    },
    [PermissaoEnum.JOB_CRIACAO_UPDATE]: {
        nome: 'Gerenciar Equipe de Criação',
        descricao: 'Permite alocar e remover membros da equipe de criação nos jobs.',
    },
    [PermissaoEnum.MENU_CRIACAO]: {
        nome: 'Menu Criação',
        descricao: 'Exibe o menu de criação.',
    },
    [PermissaoEnum.ROTA_CRIACAO_JOBS]: {
        nome: 'Rota Jobs Criação',
        descricao: 'Acesso à rota de jobs do módulo de Criação.',
    },
    [PermissaoEnum.MENU_PRODUCAO_GRAFICA]: {
        nome: 'Menu Produção Gráfica',
        descricao: 'Exibe o menu de produção gráfica.',
    },
    [PermissaoEnum.ROTA_PLANILHAS_PRODUCAO_GRAFICA]: {
        nome: 'Rota Planilhas Produção Gráfica',
        descricao: 'Acesso às rotas de produção gráfica.',
    },
    [PermissaoEnum.PLANILHA_PRODUCAO_GRAFICA_FIND_ALL]: {
        nome: 'Visualizar Planilhas Produção Gráfica',
        descricao: 'Permite visualizar planilhas de produção gráfica.',
    },
    [PermissaoEnum.PLANILHA_PRODUCAO_GRAFICA_CREATE]: {
        nome: 'Criar Planilha Produção Gráfica',
        descricao: 'Permite criar planilhas de produção gráfica.',
    },
    [PermissaoEnum.PLANILHA_PRODUCAO_GRAFICA_UPDATE]: {
        nome: 'Editar Planilha Produção Gráfica',
        descricao: 'Permite editar planilhas de produção gráfica.',
    },
};
